import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-carbon px-3 py-4 sm:px-6" data-id="element-78" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl items-start gap-2.5 rounded-md border-2 border-safety bg-graphite px-3 py-2.5" data-id="element-79" data-mp="1o3dnadhb4fro">
        <ShieldCheckIcon className="mt-0.5 h-9 w-9 shrink-0 text-safety" strokeWidth={1.6} aria-hidden="true" data-id="element-80" data-mp="1x4browvnqpas" />
        <div data-id="element-81" data-mp="19ehfmhj5x4rl">
          <h2 className="font-display text-[1.2rem] font-bold uppercase leading-none text-white sm:text-[1.6rem]" data-id="element-82" data-mp="19dzbyzu67o9n">
            YOUR PURCHASE IS <span className="text-safety" data-id="element-83" data-mp="14h8ymk9r36rx">100% PROTECTED</span>
          </h2>
          <p className="mt-1 text-[0.78rem] leading-[1.35] text-mist sm:text-[0.9rem]" data-id="element-84" data-mp="1j5lu7g4xenlw">
            Explore SAFETY INSPECTION PRO™ for 7 days. Access the complete 6-module inspection system
            and all 5 strategic bonuses. If it isn't right for you, contact us within 7 days for a
            full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}